import { render, staticRenderFns } from "./HealthReportReview.vue?vue&type=template&id=077fc49c&scoped=true"
import script from "./HealthReportReview.vue?vue&type=script&lang=js"
export * from "./HealthReportReview.vue?vue&type=script&lang=js"
import style0 from "./HealthReportReview.vue?vue&type=style&index=0&id=077fc49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fc49c",
  null
  
)

export default component.exports